export class ConfiguracionEmision {
   configEmisionId: string;
   emisorId: string;
   tipoDteId: string;
   maxLineasDetalle: number;
   nombreTipoDte: string;
   codigoTipoDte: number;
   activo: number;
}
